var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "#CCAF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.1665C15 7.85712 14.8817 7.56041 14.6711 7.34161C14.4605 7.12288 14.1748 7 13.8769 7C13.5791 7 13.2934 7.12288 13.0828 7.34161L9.38372 11.1837L7.93128 9.67511C7.82766 9.56367 7.70371 9.47479 7.56666 9.41364C7.42962 9.35249 7.28222 9.3203 7.13307 9.31896C6.98391 9.31761 6.836 9.34713 6.69795 9.4058C6.5599 9.46446 6.43448 9.5511 6.32901 9.66065C6.22354 9.7702 6.14013 9.90047 6.08365 10.0439C6.02717 10.1872 5.99875 10.3409 6.00004 10.4958C6.00134 10.6507 6.03233 10.8038 6.0912 10.9462C6.15007 11.0885 6.23564 11.2173 6.34293 11.3249L8.58954 13.6584C8.80019 13.8771 9.08586 14 9.38372 14C9.68158 14 9.96724 13.8771 10.1779 13.6584L14.6711 8.99139C14.8817 8.77259 15 8.47588 15 8.1665Z",
    fill: "#CCAF66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ab0287dd.svg";
export { ForwardRef as ReactComponent };